import type {Widget} from "~/components/analyticsWidgets/widgetTypes/widget";
import type {Uuid} from "@vesta/common-type-definitions/typeDefinitions";

export enum DashboardRowType {
    numberTilesRow = "59e558cd-5a1d-4fba-ab43-3b1ea2815fb3",
    chartsRow = "d61048a2-2494-41ac-b941-112c71d3085f",
    tableRow = "89764210-1234-4567-8901-234567890123",
    ladderSection = "c4e5f6a7-b8c9-4d0e-a1f2-b3c4d5e6f7a8",
    tabbedLadderSection = "e7f8a9b0-c1d2-4e3f-b4c5-d6e7f8a9b0c1",
    customNumberTileRow = "2d5d9301-5b48-4394-a1a6-192fa838671f",
};

export type LadderTab = {
    label: string;
    levelSizes: Array<number>;
    widgets: Array<Widget>;
};

export type CustomNumberTileGridConfig = {
    columns: number;
    rows: Array<Array<{
        widget: Widget;
        /** Number of grid columns occupied by this tile. Row spanning is intentionally unsupported. */
        width: number;
    }>>;
};

export type DashboardConfig = {
    id: Uuid;
    title: string;
    sections: Array<{
        id: Uuid;
        title: string;
        rows: Array<
            | {
                title: string | null;
                type: Exclude<
                    DashboardRowType,
                    DashboardRowType.tabbedLadderSection | DashboardRowType.customNumberTileRow
                >;
                widgets: Array<Widget>;
                /** Only used when type === ladderSection. Widgets are stored flat; this defines how many belong to each level. */
                levelSizes?: Array<number>;
                /** Client-only: stable key when layout prefs are applied (see dashboardLayoutPreferences). */
                layoutRowKey?: string;
            }
            | {
                id: Uuid;
                title: string | null;
                type: DashboardRowType.customNumberTileRow;
                gridConfig: CustomNumberTileGridConfig;
                layoutRowKey?: string;
            }
            | {
                title: string | null;
                type: DashboardRowType.tabbedLadderSection;
                id: Uuid;
                tabs: Array<LadderTab>;
                layoutRowKey?: string;
            }
        >;
    }>;
};
